// extracted by mini-css-extract-plugin
module.exports = {"GroupInput":"_3ccWUGxC4_z_FbSNcTstBv"};